import {ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router, UrlTree} from '@angular/router';
import {inject} from "@angular/core";
import {map} from "rxjs";
import {AuthService} from "../services/auth.service";
import Relation from "../model/relation.model";
import {Ticket} from "../model/ticket.model";

export const relationContactCanViewSelectedTicketGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  /**
   * @description check if the currently active relation can view the selected ticket
   * @file packages/hgvt/mijnomgeving/src/UI/src/config.ts - Configuration file for the application
   * @file packages/hgvt/mijnomgeving/src/UI/src/mijntrined.prod.config.ts - Production configuration file for the application
   */
  return authService.getActiveRelation().pipe(
    map((relation: Relation | null) => {
      if (!relation?.tickets) {
        return false; // Geen relatie of tickets dus mag niet
      }
      const foundTicket: Ticket | null = relation.tickets.find((ticket: Ticket) => ticket.ticket_id === route.params['id']) ?? null;

      if (foundTicket === null) {
        const path : UrlTree = router.parseUrl("/dashboard");
        return new RedirectCommand(path);
      }
      return true;
    })
  );
}
